// Keep aligned with backend/store_info/schedule_grading.py.
export function absoluteGradingEnabled(weights = {}) {
  weights = weights || {};
  const weight = weights.grade_absolute_hours_weight ?? 0;
  const allowance = weights.grade_absolute_hours_tolerance ?? 2;
  const span = weights.grade_absolute_hours_span ?? 20;
  return [weight, allowance, span].every(Number.isFinite) && weight > 0 && weight <= 1 && allowance >= 0 && span > 0;
}

export function blendBudgetPenalty(relativePenalty, actual, target, weights = {}) {
  if (!absoluteGradingEnabled(weights)) return relativePenalty;
  const weight = weights.grade_absolute_hours_weight;
  const allowance = weights.grade_absolute_hours_tolerance ?? 2;
  const span = weights.grade_absolute_hours_span ?? 20;
  const multiplier = target > actual ? (weights.grade_budget_under_multiplier ?? 0.25) : (weights.grade_budget_over_multiplier ?? 1);
  const difficulty = weights.grade_budget_difficulty_multiplier ?? 1;
  const absolute = Math.min(1, Math.max(0, Math.max(0, Math.abs(actual - target) - allowance) / span * multiplier * difficulty));
  return (1 - weight) * Math.min(1, Math.max(0, relativePenalty)) + weight * absolute;
}
